module.exports = __webpack_public_path__ + "static/media/home-carousel4.6b314a6d.webp";